export default __webpack_public_path__ + "static/rozcestnik-91dcc7b0b59dcdb9b85e31620a626c34.png";